import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 6v10H3V6h8ZM9.5 0h-5l-1 1H0v2h14V1h-3.5l-1-1ZM13 4H1v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };